import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import FeaturedSection from './components/FeaturedSection';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL;

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <CategoryGrid />
      <FeaturedSection />
      <AboutSection />
      <TestimonialSection />
      <FaqSection />
      <CtaSection />
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'CSSSpreadsheet Study',
            url: siteUrl,
            description: 'The ultimate CSSBuy Spreadsheet hub featuring 14+ product categories. Discover the best CSSBuy finds, buying guides, QC tips, and curated spreadsheet collections.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${siteUrl}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'What is a CSSBuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'A CSSBuy Spreadsheet is a curated collection of product links organized by category, making it easy to browse and discover items available through CSSBuy.',
                },
              },
              {
                '@type': 'Question',
                name: 'How often is the CSSBuy Spreadsheet updated?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Our CSSBuy spreadsheet collection is updated daily with new finds, trending items, and seasonal picks.',
                },
              },
              {
                '@type': 'Question',
                name: 'How do I use the CSSBuy Spreadsheet to find products?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Simply browse through the categories on our website and click on any category to be redirected to the full spreadsheet on kaspreadsheet.com.',
                },
              },
              {
                '@type': 'Question',
                name: 'What categories are available in the CSSBuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'We cover 14 comprehensive categories including Shoes, Hoodies, T-Shirts, Jackets, Pants, Headwear, Sets, Jersey, Accessories, Bags, Belts, Perfumes, and more.',
                },
              },
              {
                '@type': 'Question',
                name: 'Is the CSSBuy Spreadsheet free to use?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Yes! All CSSBuy spreadsheet categories are completely free to browse with no paywalls or hidden fees.',
                },
              },
              {
                '@type': 'Question',
                name: 'How do I find the best CSSBuy Spreadsheet picks?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Start with our Buying Guide articles, explore featured finds, or dive directly into any category spreadsheet on kaspreadsheet.com.',
                },
              },
            ],
          }),
        }}
      />
    </main>
  );
}